import React from 'react';
import Tooltip from 'src/components/tooltip';
import Icon from 'shared/components/icon';
import Stamp from 'src/components/Stamp/Stamp';

interface Props {
  showTooltipFlag: boolean;
}

const ChurnedText = ({showTooltipFlag = false}: Props) => {
  const infoText = 'No longer awarding on Raise Me';
  if (!showTooltipFlag) {
    return (
      <Stamp>
        <div className="college-earnings-no-earnings-status-text-content">{infoText}</div>
      </Stamp>
    );
  }

  return (
    <div className="college-earnings-no-earnings-status-text-content">
      <Tooltip title={infoText}>
        <div>
          <Stamp className="flag">
            <Icon iconType="flag" color="grey" />
          </Stamp>
        </div>
      </Tooltip>
    </div>
  );
};

export default ChurnedText;
